export default {
      id: "download_documents-usage",
      viewBox: "0 0 15 16",
      url: __webpack_public_path__ + "img/icons.svg#download_documents",
      toString: function () {
        return this.url;
      }
    }